import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ value, max, label, className = '' }) => {
  const percentage = Math.round((value / max) * 100);
  
  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-gray-300">{label}</span>
        <span className="text-sm font-semibold text-white">{percentage}%</span>
      </div>
      <div className="w-full bg-dark-300 rounded-full h-2.5">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="bg-primary-600 h-2.5 rounded-full"
        />
      </div>
    </div>
  );
};

export default ProgressBar;